import axios from "../../../../../services/api";
import Axios from "axios";
import { getEnv } from "../../../../../api";
import { PaginationParamProps } from "../../../../hooks";

export interface IServiceInterface {
  findAll: (
    params: PaginationParamProps,
    body: Record<string, any>,
    controller?: AbortController | AbortSignal
  ) => Promise<any>;
}

export const ErrosEnvioSasService: IServiceInterface = {
  findAll: async (params, body = {}, source) => {
    try {
      // @ts-ignore
      const response = await axios.post(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/sas/atendimentos/erros`,
        body,
        {
          params,
          // @ts-ignore
          cancelToken: source?.token,
        }
      );
      return response.data;
    } catch (error) {
      if (Axios.isCancel(error)) {
        console.log("Requisição cancelada", error.message);
      } else {
        // @ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },
};
